import { render } from "./Form.vue?vue&type=template&id=909c5cce&scoped=true"
import script from "./Form.vue?vue&type=script&lang=ts"
export * from "./Form.vue?vue&type=script&lang=ts"

import "./Form.vue?vue&type=style&index=0&id=909c5cce&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-909c5cce"

export default script